import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import styles from './styles';
import { selectUserAttributes } from '../../../store/selectors';
import { SERVICE_AREAS } from '../../../constants';
import AdditionalInformationsForm from './AdditionalInformationsForm';
const propTypes = {
  classes: PropTypes.shape({
    heading: PropTypes.string,
  }).isRequired,
  userAttributes: PropTypes.shape({
    'custom:buildingLicNo': PropTypes.string,
    'custom:businessAddress': PropTypes.string,
    'custom:businessName': PropTypes.string,
    'custom:personalEmail': PropTypes.string,
    'custom:personalPhone': PropTypes.string,
    'custom:mobileNumber': PropTypes.string,
    'custom:position': PropTypes.string,
    'custom:profileHeadline': PropTypes.string,
    'custom:serviceAState': PropTypes.string,
    'custom:serviceAType': PropTypes.string,
    'custom:skillsetBuild': PropTypes.string,
    'custom:skillsetLook': PropTypes.string,
    email: PropTypes.string,
    email_verified: PropTypes.string,
    name: PropTypes.string,
    sub: PropTypes.string,
  }).isRequired,
  businessAttributes: PropTypes.shape({
    businessNumber: PropTypes.string,
    businessName: PropTypes.string,
    businessMailingAddress: PropTypes.string,
    businessDescription: PropTypes.string,
    businessPhoneNumber: PropTypes.string,
    businessServiceAreaAddress: PropTypes.string,
    businessServiceAreaCoordinates: PropTypes.string,
    businessSkillsetBuild: PropTypes.string,
    businessSkillsetLook: PropTypes.string,
    businessPosition: PropTypes.string,
    businessApproved: PropTypes.bool,
    businessServiceAreaState: PropTypes.string,
    businessServiceAreaType: PropTypes.oneOf([
      SERVICE_AREAS.LOCAL,
      SERVICE_AREAS.NATIONAL,
      SERVICE_AREAS.STATEWIDE,
    ]),
  }).isRequired,
  enableEditing: PropTypes.bool.isRequired,
};

export const AdditionalInformations = props => {
  const { classes, userAttributes, enableEditing } = props;
  const [initialValues, setInitialValues] = useState({});

  // console.log('🚀 ~ file: index.js ~ line 61 ~ initialValues', initialValues);
  useEffect(() => {
    setInitialValues({
      'custom:newBuildsPerYear': userAttributes['custom:newBuildsPerYear'],
      'custom:businessYears': userAttributes['custom:businessYears'],
      'custom:employeesCount': userAttributes['custom:employeesCount'],
      'custom:renovationsPerYear': userAttributes['custom:renovationsPerYear'],
    });
  }, [userAttributes]);

  // const previousValues = React.useRef()

  // console.log({ initialValues }, 'initialValues con');

  return (
    <Card className={classes.cardRoot}>
      <CardHeader
        classes={{
          root: classes.cardHeaderRoot,
          title: classes.cardHeaderTitle,
        }}
        title="Additional Info"
      />
      <CardContent
        classes={{
          root: classes.cardContentRoot,
        }}
      >
        <AdditionalInformationsForm
          initialValues={initialValues}
          enableReinitialize
          enableEditing={enableEditing}
          userAttributes={userAttributes}
        />
      </CardContent>
    </Card>
  );
};

AdditionalInformations.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  userAttributes: selectUserAttributes(),
});

export default withStyles(styles)(
  connect(mapStateToProps)(AdditionalInformations),
);
